import { defineMessages } from 'react-intl';
import config from '@plone/volto/registry';
import { mergeSchemas } from '../helpers';
import { v4 as uuid } from 'uuid';

const colors = [
  {
    name: 'transparent',
    label: 'Transparent',
    style: {
      '--color-primary': 'transparent',
      '--color-secondary': 'transparent',
      '--class': 'transparent',
    },
  },
  {
    name: 'red',
    label: 'Red',
    style: {
      '--color-primary': '#aa001e',
      '--color-secondary': '#ffffff',
      '--class': 'red',
    },
  },
  {
    name: 'black',
    label: 'Black',
    style: {
      '--color-primary': '#000000',
      '--color-secondary': '#ffffff',
      '--class': 'black',
    },
  },
  {
    name: 'white',
    label: 'White',
    style: {
      '--color-primary': '#ffffff',
      '--color-secondary': '#000000',
      '--class': 'white',
    },
  },
];

const messages = defineMessages({
  Source: {
    id: 'Source',
    defaultMessage: 'Source',
  },
  Slider: {
    id: 'Slider',
    defaultMessage: 'Slider',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  alt: {
    id: 'Alt',
    defaultMessage: 'Image Alt Tag',
  },
  imageOverride: {
    id: 'Image override',
    defaultMessage: 'Image override',
  },
  item: {
    id: 'Item',
    defaultMessage: 'Item',
  },
  items: {
    id: 'Items',
    defaultMessage: 'Items',
  },
  addItem: {
    id: 'Add item',
    defaultMessage: 'Add item',
  },
  head_title: {
    id: 'Headtitle',
    defaultMessage: 'Headtitle',
  },
});

export const itemSchema = (props) =>
  mergeSchemas(
    {
      title: props.intl.formatMessage(messages.item),
      addMessage: props.intl.formatMessage(messages.addItem),
      fieldsets: [
        {
          id: 'default',
          title: 'Default',
          fields: [
            'title',
            'description',
            'href',
            'image_alt',
            'show_background',
            'color',
            'link_to',
          ],
        },
      ],

      properties: {
        href: {
          title: props.intl.formatMessage(messages.Source),
          widget: 'object_browser',
          mode: 'link',
          selectedItemAttrs: [
            'Title',
            'Description',
            'hasPreviewImage',
            'image_field',
            'image_scales',
            '@type',
          ],
          allowExternals: true,
        },
        title: {
          title: props.intl.formatMessage(messages.title),
          widget: 'string',
        },
        description: {
          title: 'Description',
          widget: 'string',
        },
        image_alt: {
          title: props.intl.formatMessage(messages.alt),
        },
        show_background: {
          title: 'show background',
          type: 'boolean',
          initialValue: false,
        },
        color: {
          title: 'color',
          type: 'string',
          widget: 'color_picker',
          colors: colors,
        },
        link_to: {
          title: 'link to',
          mode: 'link',
          widget: 'object_browser',
        },
      },
      required: [],
    },
    config.blocks.blocksConfig.slider.extensions?.slideSchema || {},
  );

export const SliderSchema = (props) =>
  mergeSchemas(
    {
      title: props.intl.formatMessage(messages.Slider),
      block: 'slider',
      fieldsets: [
        {
          id: 'default',
          title: 'Default',
          fields: ['slides'],
        },
      ],
      properties: {
        slides: {
          widget: 'object_list',
          title: props.intl.formatMessage(messages.items),
          schema: itemSchema(props),
          activeObject: props.activeObject,
          setActiveObject: props.setActiveObject,
          default: [{ '@id': uuid() }],
        },
      },
      required: [],
    },
    config.blocks.blocksConfig.slider.extensions?.blockSchema || {},
  );
